var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCottonBud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C6.10457 2 7 3.34315 7 5C7 5.968 6.31732 6.82893 5.74966 7.37748V16.6225C6.31732 17.1711 7 18.032 7 19C7 20.6569 6.10457 22 5 22C3.89543 22 3 20.6569 3 19C3 18.0324 3.68214 17.1718 4.24966 16.6232V7.37683C3.68214 6.82825 3 5.96762 3 5C3 3.34315 3.89543 2 5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2497 7.37683V16.6232C10.6821 17.1717 10 18.0324 10 19C10 20.6569 10.8954 22 12 22C13.1046 22 14 20.6569 14 19C14 18.032 13.3173 17.1711 12.7497 16.6225V7.37748C13.3173 6.82893 14 5.968 14 5C14 3.34315 13.1046 2 12 2C10.8954 2 10 3.34315 10 5C10 5.96762 10.6821 6.82825 11.2497 7.37683Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 7.37748V16.6225C20.3173 17.1711 21 18.032 21 19C21 20.6569 20.1046 22 19 22C17.8954 22 17 20.6569 17 19C17 18.0324 17.6821 17.1717 18.2497 16.6232V7.37683C17.6821 6.82825 17 5.96762 17 5C17 3.34315 17.8954 2 19 2C20.1046 2 21 3.34315 21 5C21 5.968 20.3173 6.82893 19.7497 7.37748Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCottonBud);
export default __webpack_public_path__ + "static/media/cotton-bud.679aad74a36fe13c3078bb6eac856e87.svg";
export { ForwardRef as ReactComponent };